var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.001C32 24.8375 24.8365 32.001 16 32.001C7.1635 32.001 0 24.8375 0 16.001C0 16.0048 16 0.00272656 16 0.000976562C24.8365 0.000976562 32 7.16448 32 16.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.001H16.0001C16.0001 15.9867 16.0001 15.9727 16.0001 15.9582C15.9858 15.9725 15.9716 15.9868 15.9573 16.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34879C16 5.53348 16 3.68879 16 0.000976562H15.9973C7.16194 0.00247656 0 7.16529 0 16.001H8.34781V11.3003L13.0485 16.001H15.9572C15.9715 15.9867 15.9858 15.9725 16.0001 15.9582C16.0001 14.8802 16.0001 13.9184 16.0001 13.0496L11.2992 8.34879H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.08783C5.5921 3.51277 3.51167 5.59314 2.08679 8.09558V16.0009H6.26073V6.26189V6.26177H15.9999C15.9999 4.94533 15.9999 3.6912 15.9999 2.08783H8.09454Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9566 16.001L18.6321 20.3255C19.4426 21.8887 21.0743 22.9575 22.9566 22.9575C24.839 22.9575 26.4707 21.8887 27.2812 20.3255L22.9566 16.001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 14.0335L10.3154 8.34894H8.3479V8.34906L16 16.0011H16.0001C16.0001 16.0011 16.0001 14.6444 16.0001 14.0335V14.0335Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 8.34888V16.001V16.0011C18.0869 19.7285 22.9564 20.8706 22.9564 20.8706C22.9564 20.8706 27.8259 19.7285 27.8259 16.0011V16.001V8.34888H18.0868Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9132 11.827H24.0001V17.3922H21.9132V11.827Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9566 12.8706C23.5329 12.8706 24.0001 12.4034 24.0001 11.8271C24.0001 11.2508 23.5329 10.7836 22.9566 10.7836C22.3803 10.7836 21.9131 11.2508 21.9131 11.8271C21.9131 12.4034 22.3803 12.8706 22.9566 12.8706Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4784 9.74017H20.8697V11.1315H19.4784V9.74017Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4784 12.8707H20.8697V14.262H19.4784V12.8707Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4784 16.001H20.8697V17.3923H19.4784V16.001Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0437 9.74017H26.435V11.1315H25.0437V9.74017Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0437 12.8707H26.435V14.262H25.0437V12.8707Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0437 16.001H26.435V17.3923H25.0437V16.001Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVg);
export default __webpack_public_path__ + "static/media/VG.d4d5cc36.svg";
export { ForwardRef as ReactComponent };